import React from 'react';
import { Paper, Divider, InputBase, Button, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import './SCUITextFieldWithButton.scss';

export const SCUITextFieldWithButton = (props: any) => {
    const paperClass = [props.paperClassName && props.paperClassName, 'textFieldWithButtonPaper'].filter(Boolean).join(' ');
    return (
        <Paper className={paperClass} sx={{ width: props.width ? props.width : 450 }}>
            <InputBase
                className={props.inputClassName}
                sx={{ ml: 1, flex: 1, fontSize: '1.6rem' }}
                placeholder={props.placeholder}
                onChange={props.onChange}
                onKeyDown={props.onKeyPress}
                defaultValue={props.defaultValue}
                value={props.value}
                autoFocus={props?.autoFocus}
            />
            {props.buttonText ? (
                <Button
                    color="primary"
                    sx={props.buttonSx}
                    type="button"
                    onClick={props.onClick}
                    className={[props.buttonClassName, 'textFieldWithButton'].filter(Boolean).join(' ')}
                >
                    {props.buttonText}
                </Button>
            ) : (
                <React.Fragment>
                    <Divider sx={{ height: 30, m: 0.5 }} orientation="vertical" />
                    <IconButton
                        sx={props.iconButtonSx}
                        color="primary"
                        className={['svg_icons', props.iconButtonClassName].filter(Boolean).join(' ')}
                        type="button"
                        onClick={props.onClick}
                    >
                        <SearchIcon />
                    </IconButton>
                </React.Fragment>
            )}
        </Paper>
    );
};
